import React from "react";

const ShelfContext = React.createContext({
  books: [],
  addBook: (book) => {},
  deleteBook: (id) => {},
  saveBooks: () => {},
});

export default ShelfContext;
